var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal modal-filter-details fade",
      attrs: {
        id: "modal-change-log",
        role: "dialog",
        "aria-labelledby": "location-label",
        "aria-hidden": "true",
      },
    },
    [
      _c("div", { staticClass: "modal-dialog modal-lg" }, [
        _c("div", { staticClass: "modal-content" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "modal-body" }, [
            _c(
              "ul",
              { staticClass: "change-log" },
              _vm._l(_vm.history, function (item) {
                return _c("booking-history-modal-item", {
                  key: item.id,
                  attrs: { item: item },
                })
              }),
              1
            ),
          ]),
          _vm._v(" "),
          _vm._m(1),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "h4",
        { staticClass: "modal-title", attrs: { id: "location-label" } },
        [_vm._v("Booking Change Log")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-footer" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-danger",
          attrs: { type: "button", "data-dismiss": "modal" },
        },
        [_c("i", { staticClass: "fa fa-close" }), _vm._v(" Close")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }